import React from 'react'
import { useSymbolPrices } from '../../../context/WebSocketContext'

export default function High({ symbolId, digits }) {
    const { [symbolId]: symbol } = useSymbolPrices();

    return <span>{symbol?.high?.toFixed(digits)}</span>;
}
